import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage4 from './main-component/HomePage4/HomePage4';
import Privacy from './main-component/Legal/Privacy';
import Cookies from './main-component/Legal/Cookies';
import Terms from './main-component/Legal/Terms';
import CookieConsent from './components/CookieConsent/CookieConsent';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './components/hero4/hero4.css';

function App() {
  return (
    <div className="App" id='scrool'>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage4 />} />
          <Route path="/home" element={<HomePage4 />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        <CookieConsent/>
      </BrowserRouter>
      <ToastContainer/>
    </div>
  );
}

export default App;